import React, { useState, useEffect } from "react";
import api from "../../../Services/api";
import { useParams } from "react-router-dom";
import Comentario from "../../../Comentarios";

const Noticias = (props: any) => {
  
  const [noticias, setNoticias] = useState<any>(); //{ Title: "", Corpo: "", CorpoTitle: "", Extra: "", ExtraTitle: "", video: "" });
  
  const link = useParams();
  // get url query params

  var noticiaIdStr = window.location.toString().split('Id=')[1];

  useEffect(() => {

    var noticiaId = parseInt(noticiaIdStr);

    api.get(`ObterNoticiasDetalhada?Id=${noticiaIdStr}`).then(response => {

      const noticia = response.data.results.find(
        (noticiaCompleta: { Id: 0 }) => noticiaCompleta.Id === noticiaId
      );
      if (noticia) {
        
        setNoticias(noticia);

      } else {
        throw new Error("Noticia não encontrada");
      }
    }).catch(error => {
      throw new Error(error);
    });

  }, [noticiaIdStr]);

  useEffect(() => {
    if (noticias?.Title) {
      document.title = "Noticias - " + noticias?.Title;
    }
  }, [noticias]);

  function renderObjectBody(data: any) {
    return { __html: data }
  }
  return (
    <>
      <div className="_the-content page-extrato pt-lg-6 pb-10">
        <div className='container'>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              {noticias &&

                <div className="content">

                  {noticias.Corpo &&
                    <> <span dangerouslySetInnerHTML={renderObjectBody(noticias.Corpo)} />

                      <hr></hr> </>}

                  {noticias.Extra &&
                    <><span dangerouslySetInnerHTML={renderObjectBody(noticias.Extra)} /><hr className="my-7"></hr></>
                  }

                </div>

              }

              <Comentario link={link.id} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Noticias;


